import React, { FC, useState } from 'react';
import { Col, Row, Button, FormGroup, Input } from 'reactstrap';
import { Link } from "react-router";
import { ToastContainer } from "react-toastify";
import { useAppDispatch, useAppSelector } from 'config/hooks';
import { signInUser } from '../../reducers/auth';
import storage from 'utils/storage';
import LoginCodeStep from './LoginCodeStep';
import PasskeySignIn from './PasskeySignIn';

type TUserData = {
  email: string;
  password: string;
}

const LoginBoxed: FC = () => {
  const dispatch = useAppDispatch();
  const errorsRaw = useAppSelector((state) => state.auth.errors);
  const errors = errorsRaw ?? [];
  const isLoading = useAppSelector((state) => state.auth.isLoading);
  const awaitingCode = useAppSelector((state) => !!state.auth.loginCode);
  const [userData, setUserData] = useState<TUserData>({ email: '', password: '' });

  const submitForm = async () => {
    storage.clear();
    dispatch(signInUser(userData) as any);
  };

  return (<div className="h-100 bg-plum-plate bg-animation">
    <div className="d-flex h-100 justify-content-center align-items-center">
      <Col md="8" className="mx-auto app-login-box">
          <div className="modal-dialog w-100 mx-auto">
            <div className="modal-content">
              {awaitingCode ? <LoginCodeStep /> : <>
                <div className="modal-body">
                    <div className="app-logo mx-auto mb-3"/>
                      <div className="h5 modal-title text-center">
                      </div>
                      <Row form>
                          <Col md={12}>
                              <FormGroup>
                                  <Input
                                    value={userData.email}
                                    onChange={(e) => setUserData((uData: TUserData) => {
                                      return { ...uData, email: e.target.value }
                                    })}
                                    type="email" name="email" id="email"
                                    autoComplete="username webauthn"
                                    placeholder="Email..."/>
                              </FormGroup>
                          </Col>
                          <Col md={12}>
                              <FormGroup>
                                  <Input value={userData.password}
                                    onChange={(e) => setUserData((uData: TUserData) => {
                                      return { ...uData, password: e.target.value }
                                    })}
                                    onKeyDown = {(e) => {
                                      if(e.key === "Enter") {
                                        submitForm();
                                      }
                                    }}
                                    type="password" name="password" id="password"
                                    placeholder="Password..."/>
                              </FormGroup>
                          </Col>
                      </Row>
                    <div className="text-center">
                      { errors.map((e: any, i: number) => <div key={`e${i}`} className="text-danger">{ e }</div>) }
                    </div>
                    <PasskeySignIn />
                </div>
                <div className="modal-footer clearfix">
                    <div className="float-left">
                        <Link to="/forgot-password">Forgot password?</Link>
                    </div>
                    <div className="float-right">
                        <Button color="primary" disabled={isLoading} size="lg" onClick={submitForm}>Login</Button>
                    </div>
                </div>
              </>}
            </div>
          </div>
      </Col>
    </div>
    {/* The app's ToastContainer only mounts once signed in. Without this one,
        code-step toasts ("We sent you a new code", resend errors) are queued
        by react-toastify and replayed on the home page after sign-in. Toasts
        shown here go away with the sign-in screen. */}
    <ToastContainer autoClose={2000} />
  </div>);
};

export default LoginBoxed;
